/******************************************************************************

 @File         OGLES2Navigation.cpp

 @Title        Navigation

 @Version      

 @Copyright    Copyright (c) Imagination Technologies Limited.

 @Platform     Independent

 @Description  Demonstrates a method of rendering a navigation application using
               OpenGL ES 2.0

******************************************************************************/
import { useStaticQuery, graphql } from "gatsby"
//import pvrShell from "./webgl/PVRShell"
import PVRTexture from "./webgl/Tools/PVRTexture"
import PVRShader from "./webgl/Tools/PVRShader"
import {PVRMatrix4x4, PVRVector3, PVRVector2, PVRVector4} from "./webgl/Tools/PVRMaths"
import PVRFileStream from "./webgl/Tools/PVRFileStream"
import PVRMaths from "./webgl/Tools/PVRMaths"
import {PVRPrint3D, EPVRPrint3D} from "./webgl/Tools/PVRPrint3D"
import PVRMesh from "./webgl/Tools/PVRMesh"
import PVRModel from "./webgl/Tools/PVRModel"
import {PVRPODLoader, EPODErrorCodes } from "./webgl/Tools/PVRPODLoader"
import PVRMapBucket from "./webgl/Tools/PVRMapBucket"
/******************************************************************************
 Class forward declarations
******************************************************************************/

 const WebGLNavigation2DSim = function(data){
/******************************************************************************
 Defines
******************************************************************************/


let documentData = data
   
let dataResult = function(thisdata, a, b)  {
     
    return   thisdata.filter(function(elt)  {
        return elt.endsWith(b) && elt.includes(a)
    })[0]
    }


const myresult = (documentData.allFile.edges.map((file, index) => {return (file.node.publicURL ) }))


let getFileLocation = function(name) {
	const dataResult = function(thisdata, a, b)  {
		return   thisdata.filter(function(elt)  {
			return elt.endsWith(b) && elt.includes(a)
		})[0]
		}
		let r1 = name.split(".")
		//let result = data.allFile.edges.map((file, index) => {return (file.node.publicURL ) })
			return (
				dataResult(myresult, r1[0],r1[1])
			)
		}



// const data = useStaticQuery(graphql`
//     query {
//       placeholderImage: file(relativePath: { eq: "lakes.jpg" }) {
//         childImageSharp {
//           fluid(maxWidth: 1300) {
//             ...GatsbyImageSharpFluid
//           }
//         }
//       }
//     }
//   `)

// All indices will be made up of 16 bit unsigned integers
//typedef PVRTuint16 index_t;

// Index the attributes that are bound to vertex shaders
let  VERTEX_ARRAY	 = 	0;
let TEXCOORD_ARRAY	 =	1;
let WORDINDEX_ARRAY = 		1;
let  ATTRIB_ARRAY	= 	2;

let  MAPFILEIO_SECURITYCHECKPOINT =   0xFACEBEED;
let  MAPFILEIO_VERSION         =    1;


function DEG2RAD(x) {return 0.0174532925199432 * (x);}


/****************************************************************************
** Enums
****************************************************************************/

let RenderMethod = 
{
	RENDER_FLATCOLOURED: 0,
	RENDER_ANTIALIASEDLINES:1,
	RENDER_SIGNS:2,
	RENDER_TEXT:3,
	RENDER_BILLBOARD_TEXT:4,
	RENDER_DISABLED:5,
};

/****************************************************************************
** Structures
****************************************************************************/

/*!***********************************************************************
 *	@Struct PVRTBoundingBox2D
 *	@Brief  Structure describing a 2D bounding box. Supports all kind of
 *          set operations and provides higher level functionality.
 ************************************************************************/

let PVRTBoundingBox2D = function(a,b,c,d)
{
	// Min and max coordinates
	this.minCoords = new PVRVector2();
    this.maxCoords = new PVRVector2();
    if (a) this.minCoords.data[0]  = a;
    if (b) this.minCoords.data[1] = b;
    if (c) this.maxCoords.data[0] = c;
    if (d) this.maxCoords.data[1] = d;
};



/*!***********************************************************************
 *	@Struct PVRTBoundingCircle
 *	@Brief  Structure describing a 2D bounding circle.
 ************************************************************************/
let  PVRTBoundingCircle = function()
{
	this.center= new PVRVector2();
	this.radius = 0;
};

/*!***********************************************************************
 *	@Struct PVRTViewFrustum
 *	@Brief  Structure containing all view frustum corners.
 ************************************************************************/
let PVRTViewFrustum = function()
{
	// Encoding:
	// n == near, f == far, t == top, b == bottom, l == left, r == right
	 this.ntl = new PVRVector3() ;
	 this.ntr = new PVRVector3();
	 this.nbl = new PVRVector3();
	this.nbr =  new PVRVector3();
	this.ftl = new PVRVector3() ;
	 this.ftr = new PVRVector3();
	 this.fbl = new PVRVector3();
	this.fbr =  new PVRVector3();

};

/*!***********************************************************************
 *	@Struct PVRTVertex
 *	@Brief  Stores two-dimensional position and texture coordinates.
 ************************************************************************/
let PVRTVertex = function()
{
	this.position= new PVRVector2();
	this.texcoord= new PVRVector2();
};

/*!***********************************************************************
 *	@Struct PVRTPivotQuadVertex
 *	@Brief  The PivotQuadVertex structure describes a single vertex within
 *          a screen-space aligned series of quads. It contains the origin
 *          position, the word index determining the position of the letter
 *          within the word, the quad index which determines the position of
 *          the vertex within the quad and texture coordinates.
 ************************************************************************/
let PVRTPivotQuadVertex = function()
{
	this.origin = new PVRVector2()
	this.word_index = 0
	this.height_index = 0
	this.u = 0
	this.v = 0
};


let ENodeNames =
    {
        eNODE_GROUND : 0,
        eNODE_BOXES : 1,
        eNODE_OLDBOAT : 2,
        eNODE_COINS : 3,
        eNODE_SHIP : 4,
        eNODE_SAILS : 5,
        eNODE_SHIPFLAG : 6,
        eNODE_PALMTREETRUNK : 7,
        eNODE_PALMLEAVES : 8,
        eNODE_SIZE : 9,
	};
	

/*!***********************************************************************
 *	@Struct PVRTVertexDataBucket
 *	@Brief  Contains plain data.
 ************************************************************************/
let PVRTVertexDataBucket= function()
{
	     this.boundingbox = new PVRTBoundingBox2D()
	          this.size = 0;
              this.pData = {};
	};

/*!***********************************************************************
 *	@Struct PVRTIndexDataBucket
 *	@Brief  A bucket indexset is a regular indexset which is defined within
 *          a coordinate bucket. The bounding box describes the extents of
 *          the contained primitives, which are defined	by the indexset.
 ************************************************************************/
let PVRTIndexDataBucket = function()
{
	           this.bucketindex = 0
	    this.boundingbox = new PVRTBoundingBox2D()
	           this.numIndices = 0
	             this.pIndices = {}
};

/*!***********************************************************************
 *	@Struct PVRTMapBucket
 *	@Brief  A map bucket is a regular map layer which has been split up into
 *          smaller buckets, which contain the vertex and index data.
 *          The bounding box describes the extents of the whole map layer.
 ************************************************************************/
// let PVRTMapBucket = function()
// {
// 	      this.boundingbox = new PVRTBoundingBox2D();
// 	                 this.numVertexDataBuckets = 0;
// 	      this.pVertexDataBuckets = new PVRTVertexDataBucket();
// 	                 this.numIndexDataBuckets = 0;
// 	       this.pIndexDataBuckets = new PVRTVertexDataBucket();
// };

let PVRTMapBucket = function(ws)
{
	      this.boundingbox = new PVRTBoundingBox2D();
	                 this.numVertexDataBuckets = 0;
	      this.pVertexDataBuckets = new Array(ws);//PVRTVertexDataBucket();
	                 this.numIndexDataBuckets = 0;
	       this.pIndexDataBuckets = new Array(ws);//PVRTVertexDataBucket();
};


/*!**************************************************************************
 *	@Struct RenderCache
 *	@Brief  A rendercache object is a reference counted vertex buffer object.
 ****************************************************************************/
let RenderCache = function(ws)
{
	this.vbo = null;
	this.ibo = null;
	this.size = 0;
	this.references = 0;
      if (ws) {
		this.size = ws;
		
	  }
	
	  
	     
};


/*!**************************************************************************
 *	@Struct RenderLayer
 *	@Brief  The renderlayer is used to keep an index of active indexsets during
 *          runtime. Furthermore it contains attributes like colour and the
 *          actual method used to render the data.
 ****************************************************************************/
let RenderLayer = function()
{
			 this.mapbucket = new PVRTMapBucket();
	         this.prendercache = [];   //RenderCache()
	     this.pworkingset =  [];//new CPVRTWorkingSet()
	             this.colour = new PVRVector4();
	             this.scale = new PVRVector2();
	         this.renderpath = RenderMethod.RENDER_FLATCOLOURED;
         this.pszName = "";
};


/*!**************************************************************************
 *	@Struct LayerDescription
 *	@Brief  This structure describes a renderlayer and is just used to
 *          conveniently store each available layer.
 ****************************************************************************/
let LayerDescription = function(a,b,c,d)
{
	
	this.pszFilename = getFileLocation(a); //'';
	this.renderpath = b;//RenderMethod.RENDER_FLATCOLOURED;
	this.colour = c;//new PVRVector4();
	this.scale =  d;//new PVRVector2();
	
	
};


/*!**************************************************************************
 *	@Struct ShaderDescription
 *	@Brief  This structure describes a shader program and is just used to
 *          conveniently store each available shader.
 ****************************************************************************/
let ShaderDescription = function(a,b,c,d,e,f)
{
	this.pszVertShaderSrcFile = getFileLocation(a);//'';
	this.pszVertShaderBinFile = getFileLocation(b);//'';
	this.pszFragShaderSrcFile = getFileLocation(c);//'';
	this.pszFragShaderBinFile = getFileLocation(d);//'';
	this.ui32NumAttributes = e;//0;
	this.pszAttributes = f;//'';
};

/****************************************************************************
** Consts
****************************************************************************/

// Serves as a look-ahead value to prevent popping of non-cached geometry
     const g_fBoundingCircleShift = 0.00128;
// Global scale factor for the size of the billboard signs and letters
    const g_fPivotQuadScale      = 0.000256;
// Orientation of the plane the roads etc. are being drawn onto
   const g_MapPlane   = new PVRVector4(0.0,    0.0,    1.0,    0.0);
// Global colour presets
   const g_BackgroundColour= new PVRVector4(0.8509, 0.8392, 0.6784, 0.0);
   const g_FloorColour = new PVRVector4    (0.9411, 0.7921, 0.6078, 1.0);
 
/******************************************************************************
 Content file names
******************************************************************************/

 let g_pszSimpleAttribs    = [ "inVertex" ];
 let g_pszAttribs         = [ "inVertex", "inTexCoord" ];
 let g_pszPivotQuadAttribs = [ "inVertex", "inWordIndex", "inTexCoords" ];

  let FlatShaderDescription       = new ShaderDescription( "VertShader.vsh",                 "VertShader.vsc",                 "FragShader.fsh",                 "FragShader.fsc",                 1, g_pszSimpleAttribs );
  let AALinesShaderDescription    = new ShaderDescription( "AntiAliasedLinesVertShader.vsh", "AntiAliasedLinesVertShader.vsc", "AntiAliasedLinesFragShader.fsh", "AntiAliasedLinesFragShader.fsc", 2, g_pszAttribs );
  let AlphaMaskShaderDescription  = new ShaderDescription( "AntiAliasedLinesVertShader.vsh", "AntiAliasedLinesVertShader.vsc", "AlphaMaskFragShader.fsh",        "AlphaMaskFragShader.fsc",        2, g_pszAttribs );
  let PivotQuadShaderDescription  = new ShaderDescription( "PivotQuadVertShader.vsh",        "PivotQuadVertShader.vsc",        "PivotQuadFragShader.fsh",        "PivotQuadFragShader.fsc",        3, g_pszPivotQuadAttribs );
  let PivotQuadMaskedShaderDescription  = new ShaderDescription( "PivotQuadVertShader.vsh",  "PivotQuadVertShader.vsc",        "PivotQuadMaskedFragShader.fsh",  "PivotQuadMaskedFragShader.fsc",  3, g_pszPivotQuadAttribs );

  //let PivotQuadMaskedShaderDescription = new ShaderDescription( "PivotQuadVertShader.vsh",        "PivotQuadVertShader.vsc",        "PivotQuadFragShader.fsh",        "PivotQuadFragShader.fsc",        3, g_pszPivotQuadAttribs );
  //let PivotQuadShaderDescription  = new ShaderDescription( "PivotQuadVertShader.vsh",  "PivotQuadVertShader.vsc",        "PivotQuadMaskedFragShader.fsh",  "PivotQuadMaskedFragShader.fsc",  3, g_pszPivotQuadAttribs );


// Textures
  let c_aszTextureNameStreetSigns = getFileLocation("StreetSigns.pvr");
  let c_aszTextureNameRoad        = getFileLocation("Road.pvr");
  let c_aszTextureNameAlphabet   = getFileLocation("Alphabet.pvr");

/*!**************************************************************************
 Function declarations
****************************************************************************/

//bool ReadPVRTMapBucket(const char *pszFilename, PVRTMapBucket &layer);

/*!****************************************************************************
 Class declarations
******************************************************************************/


    
	// Print3D class used to display text


	// Camera attributes
	     //new CPVRTModelPOD();
	               let m_fFOV = 0.0;
	              let m_fAspectRatio = 0.0;
	              let m_fNearClipPlane = 0.0;
	              let m_fFarClipPlane= 0.0;

	           let m_vCameraOffset= new PVRVector3();
	           let m_vCameraFrom = new PVRVector3();
	           let m_vCameraTo = new PVRVector3();
	           let m_vCameraUp = new PVRVector3();
	           let m_vCameraDirection = new PVRVector3();
	           let m_vCameraRight = new PVRVector3();
	           let m_CameraFrustum = new PVRTViewFrustum();

	           let m_mProjectionMatrix = new PVRMatrix4x4();
	           let m_mViewProjectionMatrix = new PVRMatrix4x4();
	let m_BoundingBox = new PVRTBoundingBox2D();

	// Map layers
  
     let m_uiLayerCount = 0;

	// Texture objects
	


	// Resource tracking objects
	let m_uiLastBoundVboId = 0;
	let m_uiLastBoundIboId = 0;
	let m_uiLastBoundTextureId = 0;

	// Shader objects
	let Shader = function()
	{
		this.uiId = 0;
		this.uiVertexShaderId = -1;
		this.uiFragmentShaderId = -1;
		this.uiModelViewProjMatrixLoc = -1;
		this.uiColourLoc = -1;
	}

	// let m_FlatShader = new Shader();
	// let m_AALinesShader = new Shader();
	// let m_AlphaMaskShader = new Shader();

	let PivotQuadShader = function()
	{
		this.uiId = 0;
		this.uiVertexShaderId = -1;
		this.uiFragmentShaderId = -1;
		this.uiModelViewProjMatrixLoc = -1;
		this.uiColourLoc = -1;
		this.uiUpVecLoc = -1;
		this.uiPivotDirectionLoc = -1;
	}
	
	// let m_PivotQuadShader = new PivotQuadShader();
	// let m_PivotQuadMaskedShader = new PivotQuadShader();


	// Time variables
	let m_ulPreviousTime = 0;
	let m_ulLastUpdate = 0;
	let m_fCameraAnimation = 0.0;
	let m_fDebugTimeMultiplier = 0.0;
	let m_bPause = false;
	let m_bRotate = false;


/*!***********************************************************************
 *	@Class  CPVRTWorkingSet
 *	@Brief  Simple set implementation.
 ************************************************************************/
function CPVRTWorkingSet(ws)
{


	// let m_puiEntries ;
	// let   m_uiMaxEntries ;
	// let   m_uiNumEntries ;


if (typeof ws == "object") 
	//CPVRTWorkingSet(const CPVRTWorkingSet &ws)
	{
		this.m_puiEntries = ws.m_puiEntries.slice() ; //new unsigned int[ws.m_uiMaxEntries];
	
	//	memcpy(m_puiEntries, ws.m_puiEntries, sizeof(unsigned int) * ws.m_uiNumEntries);
	
	this.m_uiMaxEntries = ws.m_uiMaxEntries;
	this.m_uiNumEntries = ws.m_uiNumEntries;
	}
else if (typeof ws == "number") 
//	CPVRTWorkingSet(unsigned int maxEntries)
	{
		this.m_puiEntries =   new Array(ws); //new unsigned int[maxEntries];
		this.m_uiMaxEntries = ws;
		this.m_uiNumEntries = 0;
	}


	//const unsigned int *GetEntries() const
	this.getEntries = function() 
	{
		return  this.m_puiEntries;
	}

	this.getEntry= function(index)
	{
		return this.m_puiEntries[index];
	}

	this.contains= function(entry)
	{
		for (let  i=0; i < this.m_uiNumEntries; ++i)
			if (this.m_puiEntries[i] === entry)
				return true;
		return false;
	}

	this.insert= function(entry)
	{
		if ( this.m_uiMaxEntries >  this.m_uiNumEntries)
		{
			this.m_puiEntries[ this.m_uiNumEntries] = entry;
			this.m_uiNumEntries += 1;
			return true;
		}
		return false;
	}

	this.clear= function()
	{
		this.m_uiNumEntries = 0;
	}

	this.size = function()
	{
		return  this.m_uiNumEntries;
	}

	this.capacity= function()
	{
		return  this.m_uiMaxEntries;
	}
};



/*!****************************************************************************
 @Function		LoadTextures
 @Output		pErrorStr		A string describing the error on failure
 @Return		bool			true if no error occured
 @Description	Loads the textures required for this training course
******************************************************************************/
//bool OGLES2Navigation::LoadTextures(CPVRTString* const pErrorStr)
WebGLNavigation2DSim.prototype.loadTextures = function(gl, pErrorStr)
{


	

	(function(gl,demo)
	 {

	  //c_aszTextureNameStreetSigns = "skybox.pvr";

		  PVRTexture.loadFromURI(gl, c_aszTextureNameStreetSigns, 0,
				function(gl, id, h, m)
				{
					
					demo.m_uiTextureIdStreetSigns = id;
					 //Clear the bit that denotes that this texture is loaded
					 demo.LoadingTextures &= ~(1<<0);
				
			
		
				 
					 if(gl.getError()) { alert("Error while loading texture!"); }

					 gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_NEAREST);
					 gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
					 gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
					 gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
				});
	 })(gl,this);
	

	(function(gl,demo)
	 {

		  PVRTexture.loadFromURI(gl, c_aszTextureNameAlphabet, 0,
				function(gl, id, h, m)
				{
					demo.m_uiTextureIdAlphabet = id;

					 //Clear the bit that denotes that this texture is loaded
					demo.LoadingTextures &= ~(1<<1);
					 
				 
					if(gl.getError()) { alert("Error while loading texture!"); }
					 gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
					 gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
					 gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
					 gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
				});
	 })(gl,this);

	(function(gl, demo)
		 {
			
			  PVRTexture.loadFromURI(gl, c_aszTextureNameRoad, 0,
					function(gl, id, h, m)
					{
						demo.m_uiTextureIdRoad = id;

						 //Clear the bit that denotes that this texture is loaded
					    demo.LoadingTextures &= ~(1<<2);
						 
						if(gl.getError()) { alert("Error while loading texture!"); }
						 gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
						 gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
						 gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.REPEAT);
						 gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
					});
		 })(gl, this);
	

	return true;
}


/*!****************************************************************************
 @Function		LoadShader
 @Output		pErrorStr		A string describing the error on failure
 @Input 		descr		    A struct containing all necessary information to
                                load and build the shader
 @Output		shader		    A struct containing all shader object identifiers
 @Return		bool			true if no error occured
 @Description	Loads and compiles a shader and links it into a shader program
******************************************************************************/
//bool OGLES2Navigation::LoadShader(CPVRTString* pErrorStr, const ShaderDescription &descr, Shader &shader)



WebGLNavigation2DSim.prototype.loadShader = function(gl, pErrorStr, descr, shader)
{
	
	shader.uiVertexShaderId = PVRShader.loadFromURI(gl, descr.pszVertShaderSrcFile, gl.VERTEX_SHADER, [], function(e){alert(e);});

//	
//	if (PVRTShaderLoadFromFile(descr.pszVertShaderBinFile, descr.pszVertShaderSrcFile, GL_VERTEX_SHADER, GL_SGX_BINARY_IMG, &shader.uiVertexShaderId, pErrorStr) != PVR_SUCCESS)
//	{
//		*pErrorStr = descr.pszVertShaderSrcFile + CPVRTString(":\n") + *pErrorStr;
//		return false;
//	}

	shader.uiFragmentShaderId = PVRShader.loadFromURI(gl, descr.pszFragShaderSrcFile, gl.FRAGMENT_SHADER, [], function(e){alert(e);});

//	
//	if (PVRTShaderLoadFromFile(descr.pszFragShaderBinFile, descr.pszFragShaderSrcFile, GL_FRAGMENT_SHADER, GL_SGX_BINARY_IMG, &shader.uiFragmentShaderId, pErrorStr) != PVR_SUCCESS)
//	{
//		*pErrorStr = descr.pszFragShaderSrcFile + CPVRTString(":\n") + *pErrorStr;
//		return false;
//	}


//	// Set up and link to the shader program
//	if (PVRTCreateProgram(&shader.uiId, shader.uiVertexShaderId, shader.uiFragmentShaderId, descr.pszAttributes, descr.ui32NumAttributes, pErrorStr))
//	{
//		*pErrorStr = descr.pszFragShaderSrcFile + CPVRTString(":\n") + *pErrorStr;
//		return false;
//	}


		shader.uiId = PVRShader.createProgram(gl,  shader.uiVertexShaderId, shader.uiFragmentShaderId, descr.pszAttributes, function(e){alert(e);});

		

	return true;
}



/*!****************************************************************************
 @Function		LoadShaders
 @Output		pErrorStr		A string describing the error on failure
 @Return		bool			true if no error occured
 @Description	Loads and compiles shaders and links them to shader programs
******************************************************************************/
//bool OGLES2Navigation::LoadShaders(CPVRTString* pErrorStr)
WebGLNavigation2DSim.prototype.loadShaders = function(gl, pErrorStr)
{
	//	Load and compile the shaders from files.
	//	Binary shaders are tried first, source shaders are used as fallback.

	// FlatShader
	
	//

	
	if (!this.loadShader(gl,pErrorStr, FlatShaderDescription, this.m_FlatShader = new  Shader()))
	{
		//pvrShellSet(prefExitMessage, pErrorStr->c_str());
		return false;
	}

	


	this.m_FlatShader.uiModelViewProjMatrixLoc = gl.getUniformLocation(this.m_FlatShader.uiId, "ModelViewProjMatrix");
	this.m_FlatShader.uiColourLoc              = gl.getUniformLocation(this.m_FlatShader.uiId, "FlatColour");
	
	// AALinesShader
	//

	if (!this.loadShader(gl,pErrorStr, AALinesShaderDescription, this.m_AALinesShader = new  Shader()))
	{
		//pvrShellSet(prefExitMessage, pErrorStr->c_str());
		return false;
	}

	//glUniform1i(glGetUniformLocation(this.m_AALinesShader.uiId, "sTexture"), 0);
	
	       gl.uniform1i(gl.getUniformLocation(this.m_AALinesShader.uiId, "sTexture"), 0);
	       
	
	 this.m_AALinesShader.uiModelViewProjMatrixLoc = gl.getUniformLocation( this.m_AALinesShader.uiId, "ModelViewProjMatrix");
	 this.m_AALinesShader.uiColourLoc              = gl.getUniformLocation( this.m_AALinesShader.uiId, "FlatColour");

	// PivotQuadShader
	//

	if (!this.loadShader(gl, pErrorStr, PivotQuadShaderDescription,  this.m_PivotQuadShader = new PivotQuadShader()))
	{
		//pvrShellSet(prefExitMessage, pErrorStr->c_str());
		return false;
	}

	
	//glUniform1i(glGetUniformLocation(this.m_PivotQuadShader.uiId, "sTexture"), 0);
	gl.uniform1i(gl.getUniformLocation( this.m_PivotQuadShader.uiId, "sTexture"), 0);
	       

	
	 this.m_PivotQuadShader.uiModelViewProjMatrixLoc = gl.getUniformLocation( this.m_PivotQuadShader.uiId, "ModelViewProjMatrix");
	 this.m_PivotQuadShader.uiUpVecLoc               = gl.getUniformLocation( this.m_PivotQuadShader.uiId, "Up");
	 this.m_PivotQuadShader.uiPivotDirectionLoc      = gl.getUniformLocation( this.m_PivotQuadShader.uiId, "PivotDirection");
	 this.m_PivotQuadShader.uiColourLoc              = gl.getUniformLocation( this.m_PivotQuadShader.uiId, "Colour");


	// PivotQuadMaskedShader
	//
	if (!this.loadShader(gl, pErrorStr, PivotQuadMaskedShaderDescription,  this.m_PivotQuadMaskedShader =  new PivotQuadShader()))
	{
		//pvrShellSet(prefExitMessage, pErrorStr->c_str());
		return false;
	}

	//glUniform1i(glGetUniformLocation(this.m_PivotQuadMaskedShader.uiId, "sTexture"), 0);
	gl.uniform1i(gl.getUniformLocation( this.m_PivotQuadMaskedShader.uiId, "sTexture"), 0);
	  
	
	 this.m_PivotQuadMaskedShader.uiModelViewProjMatrixLoc = gl.getUniformLocation( this.m_PivotQuadMaskedShader.uiId, "ModelViewProjMatrix");
	 this.m_PivotQuadMaskedShader.uiUpVecLoc               = gl.getUniformLocation( this.m_PivotQuadMaskedShader.uiId, "Up");
	 this.m_PivotQuadMaskedShader.uiPivotDirectionLoc      = gl.getUniformLocation( this.m_PivotQuadMaskedShader.uiId, "PivotDirection");
	 this.m_PivotQuadMaskedShader.uiColourLoc              = gl.getUniformLocation( this.m_PivotQuadMaskedShader.uiId, "Colour");

	
	// AlphaMaskShader
	//
	if (!this.loadShader(gl, pErrorStr, AlphaMaskShaderDescription,  this.m_AlphaMaskShader = new Shader()))
	{
		//pvrShellSet(prefExitMessage, pErrorStr->c_str());
		return false;
	}


	//glUniform1i(glGetUniformLocation(this.m_AlphaMaskShader.uiId, "sTexture"), 0);
	
	gl.uniform1i(gl.getUniformLocation( this.m_AlphaMaskShader.uiId, "sTexture"), 0);
		
	 this.m_AlphaMaskShader.uiModelViewProjMatrixLoc = gl.getUniformLocation( this.m_AlphaMaskShader.uiId, "ModelViewProjMatrix");
	 this.m_AlphaMaskShader.uiColourLoc              = gl.getUniformLocation( this.m_AlphaMaskShader.uiId, "FlatColour");

	

	return true;
}


/*!****************************************************************************
 @Function		InitApplication
 @Return		bool		true if no error occured
 @Description	Code in InitApplication() will be called by pvrShell once per
				run, before the rendering context is created.
				Used to initialize variables that are not dependant on it
				(e.g. external modules, loading meshes, etc.)
				If the rendering context is lost, InitApplication() will
				not be called again.
******************************************************************************/
//bool OGLES2Navigation::InitApplication()



	
    let loadPOD = function(stream, demo)
    {
		demo.m_CameraPod = new PVRModel();
	
		let podLoader    = new PVRPODLoader();
		let result       = podLoader.load(stream, demo.m_CameraPod);
		if(result !== EPODErrorCodes.eNoError)
		{
			alert("Failed to load POD: " + result);
			return;
		}

        // Retrieve node indexes
	    // for(let i = 0; i < ENodeNames.eNODE_SIZE; ++i)
	    // {
		//     for(let j = 0; j < demo.m_CameraPod.data.numNodes; ++j)
		//     {
		// 	    let node = demo.m_CameraPod.data.nodes[j];
		// 	    if(node.data.name === demo.c_aszNodeNames[i])
		// 	    {
		// 		    demo.NodeIndexName[j] = i;
		// 		    demo.NodeNameIndex[i] = j;
		//     	}
		//     }
	    // }

		demo.MeshesLoadFinished = true;
		
		
	}
	

// 	let loadMapBucket = function(stream, demo, i)
//     {
// 		demo.m_CameraPod = new PVRModel();
// 		//console.log("camerapodpod:",demo.m_CameraPod);
// 		let podLoader    = new PVRPODLoader();
// 		let result       = podLoader.load(stream, demo.m_CameraPod);
// 		if(result !== EPODErrorCodes.eNoError)
// 		{
// 			alert("Failed to load POD: " + result);
// 			return;
// 		}
//         // Retrieve node indexes
// 	    for(let i = 0; i < ENodeNames.eNODE_SIZE; ++i)
// 	    {
// 		    for(let j = 0; j < demo.m_CameraPod.data.numNodes; ++j)
// 		    {
// 			    let node = demo.m_CameraPod.data.nodes[j];
// 			    if(node.data.name === demo.c_aszNodeNames[i])
// 			    {
// 				    demo.NodeIndexName[j] = i;
// 				    demo.NodeNameIndex[i] = j;
// 		    	}
// 		    }
// 	    }

//         // Set light direction
//        // demo.vLightDirection = demo.m_CameraPod.getLightDirection(0);

// // 	   if (( m_paLayers[i].mapbucket.numVertexDataBuckets > 0) &&
// // 	   ( m_paLayers[i].mapbucket.numIndexDataBuckets > 0))
// //    {
// // 		m_paLayers[i].prendercache = new RenderCache([ m_paLayers[i].mapbucket.numVertexDataBuckets]);
// // 		m_paLayers[i].pworkingset = new CPVRTWorkingSet( m_paLayers[i].mapbucket.numIndexDataBuckets);
// // 		m_paLayers[i].renderpath =  layerdescriptions[i].renderpath;
// //    }
// 			   if (( demo.m_paLayers[i].mapbucket.numVertexDataBuckets > 0) &&
// 	   ( demo.m_paLayers[i].mapbucket.numIndexDataBuckets > 0))
//    {
// 		demo.m_paLayers[i].prendercache = new Array([ demo.m_paLayers[i].mapbucket.numVertexDataBuckets]);
// 		demo.m_paLayers[i].pworkingset = new CPVRTWorkingSet( demo.m_paLayers[i].mapbucket.numIndexDataBuckets);
// 		demo.m_paLayers[i].renderpath =  demo.layerdescriptions[i].renderpath;
//    }
	
//       demo.m_loadMapBucket &= (1<<i);
//     }




WebGLNavigation2DSim.prototype.initApplication = function(pvrShell)
{


	

// Individual layers of the map
this.layerdescriptions = //LayerDescription
[
	new	LayerDescription( "LandUseA_meshes.nav",   RenderMethod.RENDER_FLATCOLOURED,    new PVRVector4(0.752,  0.9411, 0.6,    1.0), new PVRVector2(1.0 , 1.0 ) ),
	new LayerDescription( "LandUseB_meshes.nav",   RenderMethod.RENDER_FLATCOLOURED,    new PVRVector4(0.0 ,    1.0 ,    0.0 ,    1.0 ),new PVRVector2(1.0 , 1.0 ) ),
	new	LayerDescription( "Landmark_meshes.nav",   RenderMethod.RENDER_FLATCOLOURED,   new  PVRVector4(0.627 ,  0.627 ,  0.627 ,  1.0 ), new PVRVector2(1.0 , 1.0 ) ),
	new LayerDescription( "WaterSeg_meshes.nav",   RenderMethod.RENDER_FLATCOLOURED,  new   PVRVector4(0.7215 , 0.8 ,    0.8509 , 1.0 ), new PVRVector2(1.0 , 1.0 ) ),
	new LayerDescription( "WaterPoly_meshes.nav",  RenderMethod.RENDER_FLATCOLOURED,  new   PVRVector4(0.7215 , 0.8 ,    0.8509 , 1.0 ), new PVRVector2(1.0 , 1.0 ) ),

	// Anti-aliased lines
	new LayerDescription( "RailRds_meshes.nav",    RenderMethod.RENDER_ANTIALIASEDLINES, new PVRVector4(1.0 ,    1.0 ,    0.5 ,    1.0 ), new PVRVector2(1.0 , 1.0 ) ),
	new LayerDescription( "Streets_meshes.nav",    RenderMethod.RENDER_ANTIALIASEDLINES, new PVRVector4(0.9790 , 0.9672 , 0.9437 , 1.0 ), new PVRVector2(1.0 , 1.0 ) ),
	new LayerDescription( "SecHwys_meshes.nav",    RenderMethod.RENDER_ANTIALIASEDLINES, new PVRVector4(0.8509 , 0.6196 , 0.4156 , 1.0 ), new PVRVector2(1.0 , 1.0 ) ),
	new LayerDescription( "MajHwys_meshes.nav",    RenderMethod.RENDER_ANTIALIASEDLINES, new PVRVector4(0.8509 , 0.4745 , 0.2549 , 1.0 ), new PVRVector2(1.0 , 1.0 ) ),

	new LayerDescription( "MajHwyShield_text.nav", RenderMethod.RENDER_BILLBOARD_TEXT,  new  PVRVector4(0.0 ,    0.0 ,    0.0 ,    1.0 ), new PVRVector2(0.075 ,   0.08 ) ),
	new LayerDescription( "SecHwyShield_text.nav", RenderMethod.RENDER_BILLBOARD_TEXT,  new  PVRVector4(0.0 ,    0.0 ,    0.0 ,    1.0 ), new PVRVector2(0.075 ,   0.08 ) ),
	new LayerDescription( "Streets_text.nav",      RenderMethod.RENDER_TEXT,            new  PVRVector4(0.0 ,    0.0 ,    0.0 ,    1.0 ), new PVRVector2(0.065625 , 0.07 ) ),
	new LayerDescription( "Signs_billboards.nav",  RenderMethod.RENDER_SIGNS,            new PVRVector4(1.0 ,    1.0 ,    1.0 ,    1.0 ), new PVRVector2(0.4 , 0.475 ) ),
];



	m_bPause = false;
	m_fFOV = 45.0;
	m_fNearClipPlane = 0.001;
	m_fFarClipPlane = 0.01;
	for (let i = 0 ; i < 3; ++i)
	{
		this.LoadingTextures |= (1<<i);
	}

	this.m_uiTextureIdStreetSigns = {};
   this.m_uiTextureIdRoad = {};
	this.m_uiTextureIdAlphabet = {};
	

	this.MeshesLoadFinished = false;

	// this.c_aszNodeNames =
    // [
    //     "Ground",
    //     "Boxes",
    //     "OldBoat",
    //     "Coins",
    //     "Ship",
    //     "Sails",
    //     "ShipFlag",
    //     "PalmTreeTrunk",
    //     "PalmTreeLeaves",
	// ];
	
	// Get and set the read path for content files
	//CPVRTResourceFile::SetReadPath((char*)pvrShellGet(prefReadPath));

	// Get and set the load/release functions for loading external files.
	// In the majority of cases the pvrShell will return NULL function pointers implying that
	// nothing special is required to load external files.
//	CPVRTResourceFile::SetLoadReleaseFunctions(pvrShellGet(prefLoadFileFunc), pvrShellGet(prefReleaseFileFunc));

//	if (PVR_SUCCESS != m_CameraPod.ReadFromFile("cameratrack.pod"))
//	{
//		pvrShellSet(prefExitMessage, "Error: Failed to parse POD cameratrack.\n");
//		return false;
//	}
	
	
	 (function(demo)
		{
			 let fs = new PVRFileStream();
			 fs.Open(getFileLocation("trackcamera.pod"), true, loadPOD, demo);
			//fs.Open("Scene.pod", true, loadPOD, demo);
		})(this);
		



	// Load each layer of the map
	m_uiLayerCount = 13; //sizeof(this.layerdescriptions) / sizeof(this.layerdescriptions[0]);
	this.m_paLayers = new Array( m_uiLayerCount) ; // new RenderLayer( m_uiLayerCount);

	this.m_loadMapBucket = 0b1111111111111;

	for (let i=0; i <  m_uiLayerCount; ++i)
	{   
		this.m_paLayers[i] = new RenderLayer();
		this.m_paLayers[i].prendercache = null;
		this.m_paLayers[i].pworkingset = null;
		this.m_paLayers[i].renderpath = RenderMethod.RENDER_DISABLED;
		this.m_paLayers[i].colour = this.layerdescriptions[i].colour;
		this.m_paLayers[i].scale = this.layerdescriptions[i].scale;
		this.m_paLayers[i].pszName = this.layerdescriptions[i].pszFilename;


		 if (!this.loadPVRTMapBucket( this.layerdescriptions[i].pszFilename,  this.m_paLayers[i], this.m_paLayers[i].mapbucket, i, this.layerdescriptions[i].renderpath))
		{
			continue;
		}	
	}

	
	// Set timer variables
	 m_ulPreviousTime = pvrShell.getTimeNow();
	 m_ulLastUpdate = 0;
	 m_fCameraAnimation = 0.0;
	 m_fDebugTimeMultiplier = 1.0;

	return true;
}


/*!****************************************************************************
 @Function		QuitApplication
 @Return		bool		true if no error occured
 @Description	Code in QuitApplication() will be called by pvrShell once per
				run, just before exiting the program.
				If the rendering context is lost, QuitApplication() will
				not be called.
******************************************************************************/
//bool OGLES2Navigation::QuitApplication()
WebGLNavigation2DSim.prototype.quitApplication = function()
{
//	for (unsigned int i=0; i < m_uiLayerCount; i++)
//	{
//		delete [] m_paLayers[i].prendercache;
//		delete m_paLayers[i].pworkingset;
//
//		PVRTMapBucket &mapbucket = m_paLayers[i].mapbucket;
//		for (unsigned int j=0; j < mapbucket.numIndexDataBuckets; j++)
//			delete [] mapbucket.pIndexDataBuckets[j].pIndices;
//		delete [] mapbucket.pIndexDataBuckets;
//		for (unsigned int j=0; j < mapbucket.numVertexDataBuckets; j++)
//			delete [] mapbucket.pVertexDataBuckets[j].pData;
//		delete [] mapbucket.pVertexDataBuckets;
//	}
//	delete [] m_paLayers;

    return true;
}

/*!****************************************************************************
 @Function		InitView
 @Return		bool		true if no error occured
 @Description	Code in InitView() will be called by pvrShell upon
				initialization or after a change in the rendering context.
				Used to initialize variables that are dependant on the rendering
				context (e.g. textures, vertex buffers, etc.)
******************************************************************************/
//bool OGLES2Navigation::InitView()
WebGLNavigation2DSim.prototype.initialiseScene = function(gl, pvrShell)
{
	 m_fAspectRatio = pvrShell.data.width/ pvrShell.data.height// pvrShellGet(prefWidth) / (float)pvrShellGet(prefHeight);

	let ErrorStr;

	// Load textures
	if (!this.loadTextures(gl,ErrorStr))
	{
		//pvrShellSet(prefExitMessage, ErrorStr.c_str());
		return false;
	}




	// Load and compile the shaders & link programs
	if (!this.loadShaders(gl,ErrorStr))
	{
		//pvrShellSet(prefExitMessage, ErrorStr.c_str());
		return false;
	}



	


	// Is the screen rotated?
//	m_bRotate = pvrShellGet(prefIsRotated) && pvrShellGet(prefFullScreen);
//#ifdef _WIN32
//	if (pvrShellGet(prefWidth) < pvrShellGet(prefHeight))
//		m_bRotate = true;
//#endif

	// Initialize Print3D
	
	this.windowWidth  = pvrShell.data.width;
	this.windowHeight = pvrShell.data.height;
	
	this.Print3D = new PVRPrint3D(myresult);
	this.Print3D.setTextures(gl, pvrShell.data.width, pvrShell.data.height)

//	if(m_Print3D.SetTextures(0,pvrShellGet(prefWidth),pvrShellGet(prefHeight), m_bRotate) != PVR_SUCCESS)
//	{
//		pvrShellSet(prefExitMessage, "ERROR: Cannot initialise Print3D\n");
//		return false;
//	}

	// Enable culling and depth test
	gl.cullFace(gl.BACK);
	gl.enable(gl.CULL_FACE);
	// No depth testing when rendering a plain 2D map
	gl.disable(gl.DEPTH_TEST);
	// No stencil test required by default
	gl.disable(gl.STENCIL_TEST);
	// Disable blending by default for now, but set proper blending mode
	gl.disable(gl.BLEND);
	gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);

	// Use the ground colour for clearing
	gl.clearColor(g_BackgroundColour.data[0], g_BackgroundColour.data[1], g_BackgroundColour.data[2], 1.0);

	return true;
}

/*!****************************************************************************
 @Function		ReleaseShader
 @Return		bool		true if no error occured
 @Description	Releases a shader program including the individual shader objects.
******************************************************************************/
//bool OGLES2Navigation::ReleaseShader(Shader &shader)
WebGLNavigation2DSim.prototype.releaseShader = function(gl, shader)
{
	gl.deleteProgram(shader.uiId);
	gl.deleteShader(shader.uiVertexShaderId);
	gl.deleteShader(shader.uiFragmentShaderId);
	return true;
}

/*!****************************************************************************
 @Function		ReleaseView
 @Return		bool		true if no error occured
 @Description	Code in ReleaseView() will be called by pvrShell when the
				application quits or before a change in the rendering context.
******************************************************************************/
//bool OGLES2Navigation::ReleaseView()
WebGLNavigation2DSim.prototype.ReleaseView = function(gl)
{
	// Delete textures
	gl.deleteTextures(1,  this.m_uiTextureIdStreetSigns);
	gl.deleteTextures(1,  this.m_uiTextureIdRoad);

	// Delete program and shader objects
	this.ReleaseShader(gl,  this.m_FlatShader);
	this.ReleaseShader(gl,  this.m_AALinesShader);
	this.ReleaseShader(gl,  this.m_PivotQuadShader);
	this.ReleaseShader(gl,  this.m_PivotQuadMaskedShader);
	this.ReleaseShader(gl,  this.m_AlphaMaskShader);

	gl.deleteBuffer(this.auiVBOIds);
	// Release Print3D Textures
	this.Print3D.releaseTextures();

	return true;
}


/*!****************************************************************************
 @Function		UpdateTimer
 @Input			none
 @Description	Updates the values of the current time, previous time, current time
				in seconds, delta time and the FPS counter used in the program
******************************************************************************/
//void OGLES2Navigation::UpdateTimer()
WebGLNavigation2DSim.prototype.updateTimer = function(gl, pvrShell)
{
	let ulCurrentTime = pvrShell.getTimeNow();

	let ulTimeDelta = ulCurrentTime -  m_ulPreviousTime;
	 m_ulPreviousTime = ulCurrentTime;

	// Update the visible object four times per second
	if (ulCurrentTime -  m_ulLastUpdate > 250)
	{
		 m_ulLastUpdate = ulCurrentTime;
		this.updateObjectset(gl);
		
	}
	
	// Advance camera animation when not paused
	if (!m_bPause)
		 m_fCameraAnimation += ulTimeDelta * 0.00005 *  m_fDebugTimeMultiplier;
}


/*!****************************************************************************
 @Function		initialiseMapBucket
 @Input			none
 @Description	Updates the values of the current time, previous time, current time
				in seconds, delta time and the FPS counter used in the program
******************************************************************************/
//void OGLES2Navigation::initialiseMapBucket()
WebGLNavigation2DSim.prototype.initialiseMapBucket = function(){
  // console.log("m_loadMapBucket:",this.m_loadMapBucket);
	if (this.m_loadMapBucket > 0){ return false}
	// Determine a global bounding box, encompassing all individual bounding boxes
	m_BoundingBox =  this.m_paLayers[0].mapbucket.boundingbox;
	for (let i=1; i <  m_uiLayerCount; ++i)
	{
		if ( this.m_paLayers[i].renderpath === RenderMethod.RENDER_DISABLED) continue;
		 m_BoundingBox.minCoords.data[0] = Math.min( m_BoundingBox.minCoords.data[0],  this.m_paLayers[i].mapbucket.boundingbox.minCoords.data[0]);
		 m_BoundingBox.minCoords.data[1] =  Math.min( m_BoundingBox.minCoords.data[1],  this.m_paLayers[i].mapbucket.boundingbox.minCoords.data[1]);
		 m_BoundingBox.maxCoords.data[0] =  Math.max( m_BoundingBox.maxCoords.data[0],  this.m_paLayers[i].mapbucket.boundingbox.maxCoords.data[0]);
		 m_BoundingBox.maxCoords.data[1] =  Math.max( m_BoundingBox.maxCoords.data[1], this.m_paLayers[i].mapbucket.boundingbox.maxCoords.data[1]);
	}
	 m_vCameraOffset = new PVRVector3( m_BoundingBox.minCoords.data[0],  m_BoundingBox.minCoords.data[1], 0.0);
		
     return true;
}
/*!****************************************************************************
 @Function		RenderScene
 @Return		bool		true if no error occured
 @Description	Main rendering loop function of the program. The shell will
				call this function every frame.
				eglSwapBuffers() will be performed by pvrShell automatically.
				pvrShell will also manage important OS events.
				The user has access to these events through an abstraction
				layer provided by pvrShell.
******************************************************************************/
//bool OGLES2Navigation::RenderScene()

let shadesLoader = 0b11111;

WebGLNavigation2DSim.prototype.renderScene = function(gl, pvrShell)
{
	// Handle user input and update the timer based variables
	


		if(!this.MeshesLoadFinished) //Wait for models
		{
			return true;
		}

		if(!this.sceneInitialised)  //Wait for scene initialisation
		{
			if(!this.initialiseScene(gl, pvrShell))	return false;

			this.sceneInitialised = true;
		}
		// if (shadesLoader != 0)
		// {
		// 	console.log(shadesLoader);
		// 	return true; //Wait for texture loading
		// }

	

		if (this.LoadingTextures)
		{
			return true; //Wait for texture loading
		}


		if (!this.LoadingMapBucket)
		{
			
			if(!this.initialiseMapBucket()) return false;
			this.LoadingMapBucket = true; //Wait for texture loading
		}
	

		this.handleInput(pvrShell);
		
			this.updateTimer(gl, pvrShell);
		
			// Update the camera interpolation and extract required matrices
			this.calculateCameraMatrices();

			// Initialize id tracking variables
			 m_uiLastBoundVboId = 0;
			 m_uiLastBoundIboId = 0;
			 m_uiLastBoundTextureId = 0;


	// Setup the viewport for the whole window
	//gl.viewport(0, 0, pvrShellGet(prefWidth), pvrShellGet(prefHeight));
	
	gl.viewport(0,0, pvrShell.data.width, pvrShell.data.height);
	// Clear the color and depth buffer
	
	
	gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT | gl.STENCIL_BUFFER_BIT);

	// Disable culling and depth testing
	gl.disable(gl.CULL_FACE);
	gl.disable(gl.DEPTH_TEST);

	// Render ground

	this.renderGround(gl, this.m_FlatShader);

	//Render each layer
	for (let i=0; i <  m_uiLayerCount; ++i)
	{
		
	this.render(gl,  this.m_paLayers[i]);
	}

	// Displays the demo name and other information using the Print3D tool.
	// For a detailed explanation, see the training course IntroducingPVRTools

	// m_Print3D.DisplayDefaultTitle("Navigation", NULL, ePVRTPrint3DLogoIMG);
	this.Print3D.displayDefaultTitle("Navigation", null, EPVRPrint3D.Logo.PowerVR);
	
	this.Print3D.flush(gl);

	return true;
}


/*!****************************************************************************
 @Function		UpdateObjectset
 @Input			none
 @Description	Updates the visible object set based on the camera position and
                the intersections of the view frustum with the global map plane.
******************************************************************************/
//void OGLES2Navigation::UpdateObjectset()
WebGLNavigation2DSim.prototype.updateObjectset = function(gl)
{



	
	
	let circle = new PVRTBoundingCircle()
	this.calculateCameraBoundingCircle(g_MapPlane, g_fBoundingCircleShift, circle);

	// Update the object set for each layer
	for (let  i=0; i < m_uiLayerCount; ++i)
	{
		// If we do not render it, skip it
		if (this.m_paLayers[i].renderpath === RenderMethod.RENDER_DISABLED)
			continue;

		let pLayer = this.m_paLayers[i];

		let workingset_old = new  CPVRTWorkingSet(pLayer.pworkingset);
 		pLayer.pworkingset.clear();
	
		// If the bounding circle does not intersect the bucket layer, skip it
		if (this.circleIntersectsBoundingBox(pLayer.mapbucket.boundingbox, circle))
		{
			// Check against each individual bucket-indexset
			for (let i=0; i < pLayer.mapbucket.numIndexDataBuckets; ++i)
			{
				// Skip it if it is empty
				if (pLayer.mapbucket.pIndexDataBuckets[i].numIndices === 0) continue;
				if (this.circleIntersectsBoundingBox(pLayer.mapbucket.pIndexDataBuckets[i].boundingbox, circle)){
					
					pLayer.pworkingset.insert(i);}
			}
		}
		
  
		// Check all the old indices agains the new ones and if one entry is not
		// in the new one, drop the cache
		for (let j=0; j < workingset_old.size(); ++j)
			if (!pLayer.pworkingset.contains(workingset_old.getEntry(j)))
				this.removeBucketIndexSet(gl,pLayer, workingset_old.getEntry(j));

		// Check all the new indices agains the old ones and if one entry is not
		// in the old one, cache it

		
		for (let j=0; j < pLayer.pworkingset.size(); ++j)
		
			if (!workingset_old.contains(pLayer.pworkingset.getEntry(j)))
				this.cacheBucketIndexSet(gl,pLayer, pLayer.pworkingset.getEntry(j));
		  
	
		
	}




	// Calculate the bounding circle based on the camera frustum intersection with the global map plane.
	// Shift the resulting bounding circle towards the viewing direction to cache objects ahead.
	
	//this.calculateCameraBoundingCircle(g_MapPlane, g_fBoundingCircleShift, circle);
	
	// // Update the object set for each layer
	// for (let i=0; i <  m_uiLayerCount; i++)
	// {
	// 	// If we do not render it, skip it
	// 	if ( this.m_paLayers[i].renderpath === RenderMethod.RENDER_DISABLED)
	// 		continue;

	// 	// let pLayer =  this.m_paLayers[i]; //RenderLayer
	// 	let  workingset_old = new  CPVRTWorkingSet(this.m_paLayers[i].pworkingset);
	// 	this.m_paLayers[i].pworkingset.clear();

	// 	// If the bounding circle does not intersect the bucket layer, skip it
	// 	if (this.circleIntersectsBoundingBox(this.m_paLayers[i].mapbucket.boundingbox, circle))
	// 	{
	// 		// Check against each individual bucket-indexset
	// 		for (let  j=0; j < this.m_paLayers[i].mapbucket.numIndexDataBuckets; j++)
	// 		{
	// 			// Skip it if it is empty
	// 			if (this.m_paLayers[i].mapbucket.pIndexDataBuckets[j].numIndices === 0)
	// 				continue;
	// 			if (this.circleIntersectsBoundingBox(this.m_paLayers[i].mapbucket.pIndexDataBuckets[j].boundingbox, circle))
	// 			this.m_paLayers[i].pworkingset.insert(j);
	// 		}
	// 	}

	// 	// Check all the old indices agains the new ones and if one entry is not
	// 	// in the new one, drop the cache
	// 	for (let j=0; j < workingset_old.size(); j++)
	// 		if (!this.m_paLayers[i].pworkingset.contains(workingset_old.getEntry(j)))
	// 			this.removeBucketIndexSet(gl, this.m_paLayers[i], workingset_old.getEntry(j));

	// 	// Check all the new indices agains the old ones and if one entry is not
	// 	// in the old one, cache it
	// 	for (let j=0; j < this.m_paLayers[i].pworkingset.size(); j++)
	// 		if (!workingset_old.contains(this.m_paLayers[i].pworkingset.getEntry(j)))
	// 			this.cacheBucketIndexSet(gl, this.m_paLayers[i], this.m_paLayers[i].pworkingset.getEntry(j));
	// }
}

/*!****************************************************************************
 @Function		HandleInput
 @Description	Handles user input.
******************************************************************************/
//void OGLES2Navigation::HandleInput()
WebGLNavigation2DSim.prototype.handleInput = function(pvrShell)
{
	// Handle user input
	if (pvrShell.isKeyPressed(pvrShell.KeyNameDOWN))
		 m_bPause = ! m_bPause;
//#ifdef _DEBUG
	if (pvrShell.isKeyPressed(pvrShell.KeyNameRIGHT))
		m_fDebugTimeMultiplier *= 2.0;
	if (pvrShell.isKeyPressed(pvrShell.KeyNameLEFT))
		m_fDebugTimeMultiplier *= 0.5;
//#endif
}

/*!****************************************************************************
 @Function		Render
 @Input         pRenderLayer     The navigation map layer to render.
 @Description	Renders
******************************************************************************/
//void OGLES2Navigation::Render(const RenderLayer *pRenderLayer)
WebGLNavigation2DSim.prototype.render = function(gl, pRenderLayer)
{
	// Return immediately if there is nothing to render for this layer or
	// the rendering has been disabled

	

	if (pRenderLayer.renderpath === RenderMethod.RENDER_DISABLED)
		return;
//console.log("pRenderLayer.renderPath:",pRenderLayer.renderpath);
	// Determine the renderpath

	
	switch (pRenderLayer.renderpath)
	{
	case RenderMethod.RENDER_BILLBOARD_TEXT:
		{
			
			gl.enable(gl.BLEND);
			this.renderPivotQuads(gl, this.m_PivotQuadMaskedShader, pRenderLayer,  this.m_uiTextureIdAlphabet);
			break;
		}

	case RenderMethod.RENDER_SIGNS:
		{

			//console.log("RENDER_SIGNS");
	
			gl.enable(gl.BLEND);
			//this.renderPivotQuads(gl, this.m_PivotQuadShader, pRenderLayer,  this.m_uiTextureIdStreetSigns);
				this.renderPivotQuads(gl, this.m_PivotQuadShader, pRenderLayer,  this.m_uiTextureIdStreetSigns);
			break;
		}

	case RenderMethod.RENDER_TEXT:
		{
			//console.log("RENDER_TEXT");
		
			gl.enable(gl.BLEND);
			
	    	this.bindTexture(gl, gl.TEXTURE0,  this.m_uiTextureIdAlphabet);
		//	console.log(pRenderLayer);
			this.renderTriangles(gl, pRenderLayer,  this.m_AlphaMaskShader);
			break;
		}

	case RenderMethod.RENDER_ANTIALIASEDLINES:
		{
			
			//console.log("RENDER_ANTIALIASEDLINES");
			gl.enable(gl.BLEND);
			this.bindTexture(gl, gl.TEXTURE0,  this.m_uiTextureIdRoad);
			this.renderTriangles(gl, pRenderLayer,  this.m_AALinesShader);
			break;
		}

	case RenderMethod.RENDER_FLATCOLOURED:
		{
			
			//console.log("RRENDER_FLATCOLOURED");
			gl.disable(gl.BLEND);
			this.renderTriangles(gl, pRenderLayer,  this.m_FlatShader);
			break;
		}

	case RenderMethod.RENDER_DISABLED:
	default:
		{
			break;
		}
	}
}


/*!****************************************************************************
 @Function		RenderTriangles
 @Input         pRenderLayer     The navigation map layer to render.
 @Description	Draws a rectangle the size of the maps bounding boxes.
******************************************************************************/
//void OGLES2Navigation::RenderTriangles(const RenderLayer *pRenderLayer, const Shader &shader)
WebGLNavigation2DSim.prototype.renderTriangles = function(gl,pRenderLayer, shader)
{
	//if (pRenderLayer->workingset_sorted.empty())

	gl.TRUE = true
	if (pRenderLayer.pworkingset.size() === 0) return;

	let colour = pRenderLayer.colour; //PVRVector4

	gl.useProgram(shader.uiId);
	gl.uniform4fv(shader.uiColourLoc, colour.data);

	// Enable the vertex attribute arrays
	 gl.enableVertexAttribArray(VERTEX_ARRAY);
	 gl.enableVertexAttribArray(TEXCOORD_ARRAY);

	// Iterate over the active object set
	//for (unsigned int i=0; i < pRenderLayer->workingset_sorted.size(); i++)
	for (let i=0; i < pRenderLayer.pworkingset.size(); ++i)
	{
		// Get the index for the bucket
	
		const  index = pRenderLayer.pworkingset.getEntry(i);
		// Get the bucket-indexset
		const  indexdatabucket = pRenderLayer.mapbucket.pIndexDataBuckets[index];  //PVRTIndexDataBucket
	
		// Go to the next workingset item if no primitives to draw
		if (indexdatabucket.numIndices === 0)continue;

		// Move camera according to the min coords of the current bounding box as the data is stored relative to it
		let mincoords = pRenderLayer.mapbucket.pVertexDataBuckets[indexdatabucket.bucketindex].boundingbox.minCoords; //PVRVector2

		let offset = new PVRVector3(mincoords.data[0], mincoords.data[1], 0.0);
	
		
		let viewmatrix = PVRMatrix4x4.createLookAt( PVRVector3.subtract( m_vCameraFrom , offset),  PVRVector3.subtract(m_vCameraTo , offset),  m_vCameraUp); //PVRMatrix4x4
		
		let mvp =  PVRMatrix4x4.matrixMultiply( m_mProjectionMatrix , viewmatrix);  //PVRMatrix4x4

		gl.uniformMatrix4fv(shader.uiModelViewProjMatrixLoc,  false, mvp.data);
		
		// Get the VBO id from the rendercache
		const  cache = pRenderLayer.prendercache[indexdatabucket.bucketindex]; //RenderCache
		if (cache.references === 0)
		{
			console.log("Error: Tried to draw non-cached bucket!");
           

			continue;
		}

		this.bindVBO(gl, cache.vbo);
		this.bindIBO(gl, cache.ibo);
		// Set the vertex attribute offsets
	// gl.enableVertexAttribArray(VERTEX_ARRAY);
	
	    gl.vertexAttribPointer(VERTEX_ARRAY, 2, gl.FLOAT, false, 16, 0);
	//	gl.enableVertexAttribArray(TEXCOORD_ARRAY);
		gl.vertexAttribPointer(TEXCOORD_ARRAY, 2, gl.FLOAT, true, 16,  8);//(const void*)offsetof(PVRTVertex, texcoord));

		// Draw the triangles
		
	// Mesh.data.vertexElements["POSITION0"];
    //   Mesh.data.vertexElements["NORMAL0"];
    //   console.log("pos:" ,this.m_CameraPod.data.vertexElements["POSITION0"]);
	//   console.log( "nomal",Mesh.data.vertexElements["NORMAL0"]);
	//   console.log( "texture",Mesh.data.vertexElements["UV0"]);


		gl.drawElements(gl.TRIANGLES, indexdatabucket.numIndices , gl.UNSIGNED_SHORT, 0);
	//	gl.drawElements(gl.TRIANGLES, indexdatabucket.numIndices, gl.UNSIGNED_SHORT, indexdatabucket.pIndices);
	// if(gl.getError()&& !this.once ){
	// 	this.once = true;
	// 	console.log(pRenderLayer);
	// 	console.log(index);
	// 	console.log(indexdatabucket.bucketindex);
	// console.log(indexdatabucket.numIndices);
	// }
	//gl.bindBuffer(gl.ARRAY_BUFFER, null);
	
	//	

		// Set the vertex attribute offsets
//		let positions = Mesh.data.vertexElements["POSITION0"];
//		let normals   = Mesh.data.vertexElements["NORMAL0"];
//		let uvs       = Mesh.data.vertexElements["UV0"];
//		gl.vertexAttribPointer(VERTEX_ARRAY, positions.numComponents, gl.FLOAT, false, positions.stride, positions.offset);
//		gl.vertexAttribPointer(NORMAL_ARRAY, normals.numComponents, gl.FLOAT, false, normals.stride, normals.offset);
//		gl.vertexAttribPointer(TEXCOORD_ARRAY, uvs.numComponents, gl.FLOAT, false, uvs.stride, uvs.offset);
//		///  gl.vertexAttribPointer(VERTEX_ARRAY, 3, gl.FLOAT, false, 4*5, 0);

	}
	
	gl.disableVertexAttribArray(VERTEX_ARRAY);
	gl.disableVertexAttribArray(TEXCOORD_ARRAY);

     gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
	gl.bindBuffer(gl.ARRAY_BUFFER, null);
	
}


/*!****************************************************************************
 @Function		RenderPivotQuads
 @Description	Renders a series of screen-aligned quads
******************************************************************************/
//void OGLES2Navigation::RenderPivotQuads(const PivotQuadShader &shader, const RenderLayer *pRenderLayer, GLuint textureId)
WebGLNavigation2DSim.prototype.renderPivotQuads = function(gl, shader, pRenderLayer, textureId)
{
       
	
	if (pRenderLayer.pworkingset.size() === 0)
		return;

	// Calculate the scale (product of global and local scale factors)
	const  fontscalars =   PVRVector2.scalarMultiply( pRenderLayer.scale , g_fPivotQuadScale); // PVRVector2
	let colour = pRenderLayer.colour; //PVRVector4

	// Get the current camera matrix
	 let matrix =  m_mViewProjectionMatrix; //PVRMatrix4x4
	// to extract the up and right vectors
	let up =  PVRVector3.scalarMultiply(  new PVRVector3(matrix.data[1], matrix.data[5], matrix.data[9]) , fontscalars.data[1]); //PVRVector3
	// and calculate the individual quad offset for the shader
	let pivot_dir = PVRVector3.scalarMultiply( new PVRVector3(matrix.data[0], matrix.data[4], matrix.data[8]) , fontscalars.data[0]); //PVRVector3

		

	// Bind the texture

	this.bindTexture(gl, gl.TEXTURE0, textureId);


// Activate shader
gl.useProgram(shader.uiId);
	// and set the corresponding constants
	if ( m_bRotate)
	{
		let inv_up =   new PVRVector3(-pivot_dir.data[0] , -pivot_dir.data[1], -pivot_dir.data[2] )   ;//PVRVector3
		gl.uniform3fv(shader.uiPivotDirectionLoc,  up.data);
		gl.uniform3fv(shader.uiUpVecLoc,  inv_up.data);
	}
	else
	{
		gl.uniform3fv(shader.uiUpVecLoc,  up.data);
		gl.uniform3fv(shader.uiPivotDirectionLoc, pivot_dir.data);
	}

	gl.uniform4fv(shader.uiColourLoc, colour.data);

	// Enable the vertex attribute arrays
         gl.enableVertexAttribArray(VERTEX_ARRAY);
 		 gl.enableVertexAttribArray(WORDINDEX_ARRAY);
 		 gl.enableVertexAttribArray(ATTRIB_ARRAY);

	// Iterate over the object set
	//for (unsigned int i=0; i < pRenderLayer->workingset_sorted.size(); i++)
	for (let i=0; i < pRenderLayer.pworkingset.size(); ++i)
	{
		// Get the current bucket index
		//const unsigned int index = pRenderLayer->workingset_sorted[i];
		const  index = pRenderLayer.pworkingset.getEntry(i);
		// Get the contained bucket-indexset
		const  indexdatabucket = pRenderLayer.mapbucket.pIndexDataBuckets[index]; //PVRTIndexDataBucket
		// Get the cache
		const  cache = pRenderLayer.prendercache[indexdatabucket.bucketindex]; //RenderCache
		if (cache.references === 0)
		{
			console.log("Error: Tried to draw non-cached ******** quad!");

			//pvrShellOutputDebug("Error: Tried to draw non-cached bucket!");
			continue;
		}

		// Move camera according to the min coords of the current bounding box as the data is stored relative to it
		let mincoords = pRenderLayer.mapbucket.pVertexDataBuckets[indexdatabucket.bucketindex].boundingbox.minCoords; //PVRVector2
		let offset = new PVRVector3(mincoords.data[0], mincoords.data[1], 0.0);


		let viewmatrix = new PVRMatrix4x4.createLookAt( PVRVector3.subtract( m_vCameraFrom , offset), PVRVector3.subtract( m_vCameraTo , offset),  m_vCameraUp);
		let  mvp = PVRMatrix4x4.matrixMultiply( m_mProjectionMatrix , viewmatrix);  //PVRMatrix4x4

		gl.uniformMatrix4fv(shader.uiModelViewProjMatrixLoc,  false, mvp.data);
		
		this.bindVBO(gl, cache.vbo);
		this.bindIBO(gl, cache.ibo);
		
		// Set the vertex attribute offsets
		let stride = 12;//sizeof(PVRTPivotQuadVertex);
		
		// glVertexAttribPointer(VERTEX_ARRAY, 2, GL_FLOAT, GL_FALSE, stride, 0);
		// glVertexAttribPointer(WORDINDEX_ARRAY, 2, GL_BYTE, GL_FALSE, stride, (const void *)offsetof(struct PVRTPivotQuadVertex, word_index));//
		// glVertexAttribPointer(ATTRIB_ARRAY, 2, GL_UNSIGNED_BYTE, GL_TRUE, stride, (const void *)offsetof(struct PVRTPivotQuadVertex, u));

		
		gl.vertexAttribPointer(VERTEX_ARRAY, 2, gl.FLOAT, false, stride, 0);
		
		gl.vertexAttribPointer(WORDINDEX_ARRAY, 2, gl.BYTE, false, stride, 8);

		gl.vertexAttribPointer(ATTRIB_ARRAY, 2, gl.UNSIGNED_BYTE, true, stride, 10);


		// Skip if there is nothing to draw
		if (indexdatabucket.numIndices > 0)
		{
			// Draw the actual pivot quads
			//gl.drawElements(gl.TRIANGLES, indexdatabucket.numIndices, gl.UNSIGNED_SHORT, indexdatabucket.pIndices);
		gl.drawElements(gl.TRIANGLES, indexdatabucket.numIndices, gl.UNSIGNED_SHORT, 0);	
		
	}
	
	

	}

	 gl.disableVertexAttribArray(VERTEX_ARRAY);
	 gl.disableVertexAttribArray(WORDINDEX_ARRAY);
	gl.disableVertexAttribArray(ATTRIB_ARRAY);

	gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
	gl.bindBuffer(gl.ARRAY_BUFFER, null);
}


/*!****************************************************************************
 @Function		RenderGround
 @Description	Draws a rectangle the size of the maps bounding boxes.
******************************************************************************/
//void OGLES2Navigation::RenderGround()
WebGLNavigation2DSim.prototype.renderGround = function(gl, shader)
{

	gl.useProgram( shader.uiId);

	gl.uniformMatrix4fv( shader.uiModelViewProjMatrixLoc,  false,  m_mViewProjectionMatrix.data);
	 let col = g_FloorColour;  //PVRVector4
	gl.uniform4fv( shader.uiColourLoc,  col.data);

	// Enable vertex arributes
	
	let minCorner = m_BoundingBox.minCoords;
	let maxCorner = m_BoundingBox.maxCoords;

	const  afVertexData = [ minCorner.data[0], minCorner.data[1], 0.0, maxCorner.data[0], minCorner.data[1], 0.0,
		                           minCorner.data[0], maxCorner.data[1], 0.0, maxCorner.data[0], maxCorner.data[1], 0.0 ];

	 if(!this.auiVBOIds) {this.auiVBOIds = gl.createBuffer();}
								   
	  gl.bindBuffer(gl.ARRAY_BUFFER, this.auiVBOIds);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(afVertexData), gl.DYNAMIC_DRAW); 
								

	gl.enableVertexAttribArray(VERTEX_ARRAY);
	gl.vertexAttribPointer(VERTEX_ARRAY, 3, gl.FLOAT, false, 0, 0);

	//Kept if adding a texture is wanted
	// let  afTexCoordData = [ 0, 0,  1, 0,  0, 1,  1, 1 ];
	// gl.enableVertexAttribArray(TEXCOORD_ARRAY);
	// gl.vertexAttribPointer(TEXCOORD_ARRAY, 2, gl.FLOAT, false, 0, afTexCoordData);

	// Draw the quad
	gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);

	// Safely disable the vertex attribute arrays
	gl.disableVertexAttribArray(VERTEX_ARRAY);
	//gl.disableVertexAttribArray(TEXCOORD_ARRAY);
	gl.bindBuffer(gl.ARRAY_BUFFER, null);
}


/*!****************************************************************************
 @Function		CacheBucketIndexSet
 @Description	Creates a VBO of a bucket of coordinates and adds it to the
                cache queue of the map tile or increases reference count if
				already cached.
******************************************************************************/
//void OGLES2Navigation::CacheBucketIndexSet(RenderLayer *pRenderLayer, const unsigned int bucketindex)
WebGLNavigation2DSim.prototype.cacheBucketIndexSet = function(gl, pRenderLayer, bucindex)
{
	// Retrieve referenced rendercache entity



	let  index = pRenderLayer.mapbucket.pIndexDataBuckets[bucindex].bucketindex;
	let rendercache = pRenderLayer.prendercache[index];
	// If it is already cached do nothing
	
	if (rendercache.references > 0)
	{
		rendercache.references = rendercache.references + 1;
		return;
	}

	// Not cached, so create VBO now
	let vertexdatabucket = pRenderLayer.mapbucket.pVertexDataBuckets[index];
	rendercache.size = vertexdatabucket.size;
	rendercache.references = 1;


    rendercache.vbo = gl.createBuffer();
	gl.bindBuffer(gl.ARRAY_BUFFER, rendercache.vbo);
	gl.bufferData(gl.ARRAY_BUFFER, vertexdatabucket.pData, gl.STATIC_DRAW);
	gl.bindBuffer(gl.ARRAY_BUFFER, null);

	let vertexindexbucket = pRenderLayer.mapbucket.pIndexDataBuckets[bucindex];
    rendercache.ibo = gl.createBuffer();
	 gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, rendercache.ibo);
	 gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, vertexindexbucket.pIndices, gl.STATIC_DRAW);
	 gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);

}

/*!****************************************************************************
 @Function		RemoveBucketIndexSet
 @Description	Decreases reference count of VBO and removes VBO if not
                required any longer.
******************************************************************************/
//void OGLES2Navigation::RemoveBucketIndexSet(RenderLayer *pRenderLayer, const unsigned int bucketindex)
WebGLNavigation2DSim.prototype.removeBucketIndexSet = function(gl,pRenderLayer, bucindex)
{
	const index = pRenderLayer.mapbucket.pIndexDataBuckets[bucindex].bucketindex;
	let rendercache = pRenderLayer.prendercache[index];
	if (rendercache.references === 0)
	{
		console.log("Error: Tried to remove non-cached element!");
		return;
	}


	rendercache.references = rendercache.references - 1;


	// Remove if reference count reaches zero
	if (rendercache.references === 0)
	{
		gl.deleteBuffer( rendercache.vbo);
		rendercache.vbo = null
		gl.deleteBuffer( rendercache.ibo);
		rendercache.ibo = null
		rendercache.size = 0;
	}

}

/*!****************************************************************************
 @Function		BindVBO
 @Description	Checks whether the given VBO is already bound and binds it if
                necessary.
******************************************************************************/
//void OGLES2Navigation::BindVBO(GLuint vbo)
WebGLNavigation2DSim.prototype.bindVBO = function(gl, vbo)
{
	// Only set the VBO if we bind a different one (optimize -> sort for vbos)
	if (vbo !==  m_uiLastBoundVboId)
	{
		// Bind the current bucket
	
		gl.bindBuffer(gl.ARRAY_BUFFER, vbo);
	
		 m_uiLastBoundVboId = vbo;
	}
}

WebGLNavigation2DSim.prototype.bindIBO = function(gl, ibo)
{
	// Only set the VBO if we bind a different one (optimize -> sort for vbos)
	if (ibo !==  m_uiLastBoundIboId)
	{
		// Bind the current bucket
	
		gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, ibo);
	
		 m_uiLastBoundVboId = ibo;
	}
}

/*!****************************************************************************
 @Function		BindTexture
 @Description	Checks whether the given texture is already bound and binds it if
                necessary. Currently only supports one global texture,
				regardless to which texture unit it is currently bound.
******************************************************************************/
//void OGLES2Navigation::BindTexture(GLenum unit, GLuint id)
WebGLNavigation2DSim.prototype.bindTexture = function(gl,unit, id)
{
	gl.activeTexture(unit);
	
	if ( m_uiLastBoundTextureId !== id)
	{
		gl.bindTexture(gl.TEXTURE_2D, id);
		 m_uiLastBoundTextureId = id;
	}
}


WebGLNavigation2DSim.prototype.rotMatrix = new PVRMatrix4x4();
/*!****************************************************************************
 @Function		CalculateCameraMatrices
 @Description	Calculates all required camera matrices.
******************************************************************************/
//void OGLES2Navigation::CalculateCameraMatrices()
WebGLNavigation2DSim.prototype.calculateCameraMatrices = function()
{
	// Animate the camera
	//if ( m_fCameraAnimation > ( m_CameraPod.nNumFrame - 2))
	
	// let  m_CameraPod = this.m_CameraPod;
	// let m_fCameraAnimation = this.m_fCameraAnimation;

	if ( m_fCameraAnimation > (this.m_CameraPod.data.numFrames - 2))
	m_fCameraAnimation = 0.0;

	this.m_CameraPod.setCurrentFrame( m_fCameraAnimation);

	let props =  this.m_CameraPod.getCameraExtension(0, m_fCameraAnimation, m_vCameraOffset);

	m_vCameraFrom = props.from;
	m_vCameraDirection = props.direction;
	m_vCameraUp =    props.up;
	m_vCameraTo =   props.to;
    m_vCameraRight =   props.right;





		
	// m_CameraPod.setFrame( m_fCameraAnimation);

	//this.rotMatrix =  this.m_CameraPod.data.nodes[0].data.animation.getRotationMatrix(baseFrame, )
    //getRotationMatrix(this.rotMatrix, m_CameraPod.data.nodes[0]);

	//let baseFrame =  this.m_fCameraAnimation;

//	let pos0= new PVRVector3(this.m_CameraPod.data.nodes[0].pfAnimPosition[baseFrame * 3]);
//	let pos1= new PVRVector3(this.m_CameraPod.data.nodes[0].pfAnimPosition[(baseFrame + 1) * 3]);

	// Offset the camera by a reference coordinate to center it around the origin
	// This should help circumvent floating point precision problems
//	pos0 -=  this.m_vCameraOffset;
	//pos1 -=  this.m_vCameraOffset;
	//let lerp = ( this.m_fCameraAnimation - this.baseFrame);
	// this.m_vCameraFrom = pos0 + (pos1 - pos0) * lerp;
	// this.m_vCameraFrom +=  this.m_vCameraOffset;

     //let rotMatrix = this.rotMatrix

	 //let props  = this.m_CameraPod.getCameraProperties(0);   // Camera 0
	  //let aspect = pvrShell.data.width / pvrShell.data.height;
	  let viewMatrix   = PVRMatrix4x4.createLookAt(props.from, props.to, props.up);
	  //this.m_mProjectionMatrix  = PVRMatrix4x4.createPerspectiveProjection(4, 5000, props.fov, aspect);
	  //this.m_mViewProjectionMatrix =  PVRMatrix4x4.matrixMultiply( this.m_mProjectionMatrix , viewMatrix);


	// Extract camera tripod orientation from rotation matrix

	// Adjust the near and far clip plane for a tight view frustum
	this.calculateViewFrustumCorners( m_CameraFrustum);
	//this.calculateClipPlanes(m_fNearClipPlane, m_fFarClipPlane);

	//let viewMatrix = PVRMatrix4x4.createLookAt( this.m_vCameraFrom,  this.m_vCameraTo,  this.m_vCameraUp);
	 
	m_mProjectionMatrix = PVRMatrix4x4.createPerspectiveProjection(m_fNearClipPlane,  m_fFarClipPlane,  DEG2RAD( m_fFOV),  m_fAspectRatio);
	 
	 //this.m_mProjectionMatrix  = PVRMatrix4x4.PerspectiveFovRH(DEG2RAD( this.m_fFOV),  this.m_fAspectRatio,  this.m_fNearClipPlane,  this.m_fFarClipPlane, PVRMatrix4x4.OGL,  this.m_bRotate);
	
	 m_mViewProjectionMatrix =  PVRMatrix4x4.matrixMultiply( m_mProjectionMatrix , viewMatrix);

	
}


/*!****************************************************************************
 @Function		CalculateClipPlanes
 @Output        nearplane       The calculated near plane.
 @Output        farplane        The calculated far plane.
 @Description	Calculates optimal clipping planes based on the current camera
                setup and the viewable area.
******************************************************************************/
//void OGLES2Navigation::CalculateClipPlanes(float &nearplane, float &farplane)
WebGLNavigation2DSim.prototype.calculateClipPlanes = function(nearplane, farplane)
{
	// Adjust the clip planes so that the near plane is pushed away as far as possible
	// before intersecting the ground
	let lowdir = new PVRVector3((( m_CameraFrustum.fbl -  m_vCameraFrom) + ( m_CameraFrustum.fbr -  m_vCameraFrom)).normalized());
	let updir = new PVRVector3((( m_CameraFrustum.ftl -  m_vCameraFrom) + ( m_CameraFrustum.ftr -  m_vCameraFrom)).normalized());

	// Calculate the intersections with the global plane
	let u = this.calculateLinePlaneIntersection(g_MapPlane,  m_vCameraFrom, lowdir +  m_vCameraFrom);
	let v = this.calculateLinePlaneIntersection(g_MapPlane,  m_vCameraFrom, updir +  m_vCameraFrom);

	// Project the intersection onto the view direction
	nearplane = (lowdir * u).dot( m_vCameraDirection);
	farplane = (updir * v).dot( m_vCameraDirection);
}


/*!********************************************************************************************
 @Function		CalculateViewFrustumCorners
 @Output        corners        The eight vertices defining the viewfrustum shape.
 @Description	Calculates the eight viewfrustum vertices based on the current camera setup.
***********************************************************************************************/
//void OGLES2Navigation::CalculateViewFrustumCorners(PVRTViewFrustum &corners) const
WebGLNavigation2DSim.prototype.calculateViewFrustumCorners = function(corners)
{


	// let  m_vCameraFrom =  this.m_vCameraFrom;
	// let  m_vCameraDirection =  this.m_vCameraDirection;
	// let  m_fNearClipPlane =  this.m_fNearClipPlane;
	// let  m_fFarClipPlane =  this.m_fFarClipPlane;
	// let m_fFOV =  this.m_fFOV;
	// let m_fAspectRatio =  this.m_fAspectRatio;
	
	const  nearcenter =  PVRVector3.add(m_vCameraFrom, PVRVector3.scalarMultiply( m_vCameraDirection ,m_fNearClipPlane));
	const  farcenter = PVRVector3.add(m_vCameraFrom ,  PVRVector3.scalarMultiply(m_vCameraDirection , m_fFarClipPlane));

	const  tang =  Math.tan(DEG2RAD(m_fFOV) * 0.5);
	const nearheight =   m_fNearClipPlane * tang;
	const  nearwidth = nearheight * m_fAspectRatio;
	const  farheight = m_fFarClipPlane  * tang;
	const  farwidth = farheight * m_fAspectRatio;

// let m_vCameraUp =  this.m_vCameraUp;
// let m_vCameraRight =  this.m_vCameraRight;

	// Near plane frustum corners
	corners.ntl = PVRVector3.subtract( PVRVector3.add( nearcenter , PVRVector3.scalarMultiply(m_vCameraUp , nearheight)) , PVRVector3.scalarMultiply(m_vCameraRight , nearwidth));
	corners.ntr = PVRVector3.add(PVRVector3.add(nearcenter , PVRVector3.scalarMultiply(m_vCameraUp , nearheight )), PVRVector3.scalarMultiply(m_vCameraRight , nearwidth));
	corners.nbl = PVRVector3.subtract(  PVRVector3.subtract(   nearcenter , PVRVector3.scalarMultiply(m_vCameraUp , nearheight)) , PVRVector3.scalarMultiply(m_vCameraRight , nearwidth));
	corners.nbr = PVRVector3.add( PVRVector3.subtract(nearcenter , PVRVector3.scalarMultiply(m_vCameraUp , nearheight)) , PVRVector3.scalarMultiply(m_vCameraRight , nearwidth));

	// Far plane frustum corners
	corners.ftl = PVRVector3.subtract(PVRVector3.add(farcenter , PVRVector3.scalarMultiply(m_vCameraUp , farheight)) , PVRVector3.scalarMultiply(m_vCameraRight , farwidth));
	corners.ftr = PVRVector3.add(PVRVector3.add(farcenter , PVRVector3.scalarMultiply(m_vCameraUp , farheight)) , PVRVector3.scalarMultiply(m_vCameraRight , farwidth));
	corners.fbl = PVRVector3.subtract( PVRVector3.subtract(farcenter , PVRVector3.scalarMultiply( m_vCameraUp , farheight)) , PVRVector3.scalarMultiply(m_vCameraRight , farwidth));
	corners.fbr = PVRVector3.add( PVRVector3.subtract(farcenter , PVRVector3.scalarMultiply(m_vCameraUp , farheight)) , PVRVector3.scalarMultiply(m_vCameraRight , farwidth));
}

/*!********************************************************************************************
 @Function		CalculateCameraBoundingCircle
 @Input         plane                The plane which will be intersected with the viewfrustum.
 @Input			shift                The resulting bounding circle will be shifted along the
				                     view direction by this amount.
 @Return        PVRTBoundingCircle   The bounding circle enclosing the intersection primitive.
 @Description	Calculates the intersection points of a viewfrustum and a plane. Only the viewfrustum
                side vectors (pointing towards the viewing direction) will be taken into account.
				The resulting intersection points are then used to calculate a bounding circle,
				which will be shifted along the viewing direction.
***********************************************************************************************/
//void OGLES2Navigation::CalculateCameraBoundingCircle(const PVRVector4 &plane, const float shift, PVRTBoundingCircle &circle)
WebGLNavigation2DSim.prototype.calculateCameraBoundingCircle = function(plane, shift,circle)
{
	// let m_CameraFrustum =  m_CameraFrustum;
	// let m_vCameraFrom =  m_vCameraFrom;
	// let m_vCameraDirection =  m_vCameraDirection;
	// let calculateLinePlaneIntersection = this.calculateLinePlaneIntersection;
	
	const a3 =  PVRVector3.add(m_vCameraFrom ,  PVRVector3.scalarMultiply( PVRVector3.subtract (m_CameraFrustum.fbl , m_vCameraFrom) , this.calculateLinePlaneIntersection(plane, m_vCameraFrom, m_CameraFrustum.fbl)));
	const b3 =  PVRVector3.add(m_vCameraFrom , PVRVector3.scalarMultiply( PVRVector3.subtract (m_CameraFrustum.fbr , m_vCameraFrom) , this.calculateLinePlaneIntersection(plane, m_vCameraFrom, m_CameraFrustum.fbr)));
	const c3 =  PVRVector3.add(m_vCameraFrom , PVRVector3.scalarMultiply( PVRVector3.subtract (m_CameraFrustum.ftl , m_vCameraFrom) , this.calculateLinePlaneIntersection(plane, m_vCameraFrom, m_CameraFrustum.ftl)));
	const d3 =  PVRVector3.add(m_vCameraFrom , PVRVector3.scalarMultiply( PVRVector3.subtract (m_CameraFrustum.ftr , m_vCameraFrom) , this.calculateLinePlaneIntersection(plane, m_vCameraFrom, m_CameraFrustum.ftr)));

	 const center = PVRVector3.scalarMultiply( PVRVector3.add(a3, PVRVector3.add(b3, PVRVector3.add(c3,d3))), 0.25);
//  const a = PVRVector2(a3.data[0],a3.data[1]);
//  const b = PVRVector2(b3.data[0],b3.data[1]);
//  const c = PVRVector2(c3.data[0],c3.data[1]);
//  const d = PVRVector2(d3.data[0],d3.data[1]);


	//circle.center = PVRVector2(center.data[0],center.data[1]);//(a + b + c + d) * 0.25;
	const radius =   PVRVector3.subtract(a3, center)
	 circle.radius = new PVRVector2(radius.data[0],radius.data[1]).vectorlength();//(a - circle.center).vectorlength();
	// now add a little shift towards view direction
	
	const center1 =  PVRVector3.scalarMultiply(m_vCameraDirection, shift);
	circle.center =  new PVRVector2(center.data[0] + center1.data[0],  center.data[1] + center1.data[1] );    //PVRVector2(m_vCameraDirection) * shift;
}

/*!********************************************************************************************
 @Function		CircleIntersectsBoundingBox
 @Input			bbox     The bounding box.
 @Input         circle   The bounding circle.
 @Return        bool     Indicates whether the primitives intersect or not.
 @Description	Determines whether a bounding circle and a bounding box intersect or not.
***********************************************************************************************/
//bool OGLES2Navigation::CircleIntersectsBoundingBox(const PVRTBoundingBox2D &bbox, const PVRTBoundingCircle &circle)
WebGLNavigation2DSim.prototype.circleIntersectsBoundingBox = function(bbox, circle)
{
	// Extremely simple, just add border the same width as radius. Gives false positives at edge cases!
	let extbbox = new PVRTBoundingBox2D();
	extbbox.minCoords.data[0] =   bbox.minCoords.data[0] - circle.radius;
	extbbox.minCoords.data[1] =   bbox.minCoords.data[1] - circle.radius;


	extbbox.maxCoords.data[0] =   bbox.maxCoords.data[0] + circle.radius;
	extbbox.maxCoords.data[1] =   bbox.maxCoords.data[1] + circle.radius;

	if ((circle.center.data[0] >= extbbox.minCoords.data[0]) && (circle.center.data[1] >= extbbox.minCoords.data[1]) &&
		(circle.center.data[0] <= extbbox.maxCoords.data[0]) && (circle.center.data[1] <= extbbox.maxCoords.data[1]))
		return true;
	else
		return false;
}


/*!****************************************************************************
 @Function		CalculateLinePlaneIntersection
 @Input         plane    Plane definition in normal plus distance format.
 @Input         a        First point of line.
 @Input         b        Second point of line.
 @Return		Intersection distance.
 @Description	Calculates the intersection of a line and a plane.
******************************************************************************/
//float OGLES2Navigation::CalculateLinePlaneIntersection(const PVRVector4 &plane, const PVRVector3 &a, const PVRVector3 &b) const

WebGLNavigation2DSim.prototype.calculateLinePlaneIntersection = function(plane, a,b)
{
	
	const normal = new PVRVector3(plane.data[0], plane.data[1], plane.data[2]);
	//const nom = -(normal.dot(a) + plane.w);
	const nom = 0;//-(PVRVector3.dot(normal, a) + plane.data[3]);
//  const nom = -(PVRVector3.dot(normal, a) + plane.data[3]);

	const denom =   PVRVector3.dot(normal,  PVRVector3.subtract(b,a));    // normal.dot(b - a);

	if (denom === 0.0) return 0.0;
	else return nom / denom;
}

/*!****************************************************************************
 @Function		ReadData
 @Input         pSrc     Pointer to pointer to read data from.
 @Input         size     Amount of data in bytes to copy.
 @Output        pDst     Destination buffer.
 @Description	Copies a defined amount of data from a source pointer and sets
                it after the last read byte.
******************************************************************************/
//void OGLES2Navigation::ReadData(const char **pSrc, void *pDst, PVRTuint32 size) const

WebGLNavigation2DSim.prototype.readData = function(pSrc,pDst, size)
{
	// memcpy(pDst, *pSrc, size);
	// *pSrc += size;
}

/*!****************************************************************************
 @Function		CheckMarker
 @Input         pData    Pointer to data to read the data from.
 @Input         token    Value of token to check.
 @Return		True if the marker is correct, false otherwise.
 @Description	Reads a 32-bit token from the data stream and compares it
                against the provided one.
******************************************************************************/
//bool OGLES2Navigation::CheckMarker(const char **pData, unsigned int token) const

WebGLNavigation2DSim.prototype.checkMarker = function(pData, token)
{
	let value = 0;
	//readData(pData, value, sizeof(value));
	//readData(pData, value, 4);
	return (value === token);
}

/*!********************************************************************************************
 @Function		readPVRTMapBucket
 @Input			pszFilename      Filename to read the map layer from.
 @Input			layer            The layer to write.
 @Return        bool             True if successful, false otherwise.
 @Description	Reads a map bucket from a file.
***********************************************************************************************/
//bool OGLES2Navigation::loadPVRTMapBucket(const char *pszFilename, PVRTMapBucket &layer) const
WebGLNavigation2DSim.prototype.loadPVRTMapBucket = function(pszFilename, layer, layer1, i, renderpath)
{

	return  PVRMapBucket.loadFromURI(layer1,  pszFilename, i, renderpath, this, layer, 
		function(layer1, layer,i,renderpath,demo)
		{
			if (( layer1.numVertexDataBuckets > 0) &&
			( layer1.numIndexDataBuckets > 0))
		{
			layer.prendercache = [];
  for (let i =0 ;i< layer1.numVertexDataBuckets; ++i){
	layer.prendercache.push(new RenderCache());
  }

			layer.pworkingset = new CPVRTWorkingSet( layer1.numIndexDataBuckets);
			layer.renderpath =  renderpath;
		}
	
		   demo.m_loadMapBucket &= ~(1<<i);
	

		});



	// CPVRTResourceFile file(pszFilename);
	// if (!file.IsOpen())
	// 	return false;

	// const char *pData = (const char *)file.DataPtr();

	// if (!checkMarker(&pData, MAPFILEIO_VERSION))	return false;
	// readData(&pData, &layer.boundingbox, sizeof(layer.boundingbox));

	// if (!checkMarker(&pData, MAPFILEIO_SECURITYCHECKPOINT))	return false;

	// // Read vertex data
	// readData(&pData, &layer.numVertexDataBuckets, sizeof(layer.numVertexDataBuckets));
	// if (layer.numVertexDataBuckets > 0)
	// {
	// 	layer.pVertexDataBuckets = new PVRTVertexDataBucket[layer.numVertexDataBuckets];
	// 	for (let i=0; i < layer.numVertexDataBuckets; i++)
	// 	{
	// 		readData(&pData, &layer.pVertexDataBuckets[i].boundingbox, sizeof(layer.pVertexDataBuckets[i].boundingbox));
	// 		if (!checkMarker(&pData, MAPFILEIO_SECURITYCHECKPOINT))	return false;

	// 		readData(&pData, &layer.pVertexDataBuckets[i].size, sizeof(layer.pVertexDataBuckets[i].size));
	// 		if (layer.pVertexDataBuckets[i].size == 0) return false;
	// 		layer.pVertexDataBuckets[i].pData = new char[layer.pVertexDataBuckets[i].size];
	// 		readData(&pData, layer.pVertexDataBuckets[i].pData, layer.pVertexDataBuckets[i].size);
	// 		if (!checkMarker(&pData, MAPFILEIO_SECURITYCHECKPOINT))	return false;
	// 	}
	// }
	// else
	// 	layer.pVertexDataBuckets = NULL;

	// if (!checkMarker(&pData, MAPFILEIO_SECURITYCHECKPOINT))	return false;

	// readData(&pData, &layer.numIndexDataBuckets, sizeof(layer.numIndexDataBuckets));
	// if (layer.numIndexDataBuckets > 0)
	// {
	// 	layer.pIndexDataBuckets = new PVRTIndexDataBucket[layer.numIndexDataBuckets];
	// 	for (let i=0; i < layer.numIndexDataBuckets; i++)
	// 	{
	// 		readData(&pData, &layer.pIndexDataBuckets[i].bucketindex, sizeof(layer.pIndexDataBuckets[i].bucketindex));
	// 		if (!checkMarker(&pData, MAPFILEIO_SECURITYCHECKPOINT))	return false;

	// 		readData(&pData, &layer.pIndexDataBuckets[i].boundingbox, sizeof(layer.pIndexDataBuckets[i].boundingbox));
	// 		if (!checkMarker(&pData, MAPFILEIO_SECURITYCHECKPOINT))	return false;

	// 		PVRTuint32 size;
	// 		readData(&pData, &size, sizeof(size));
	// 		layer.pIndexDataBuckets[i].numIndices = size / sizeof(index_t);
	// 		if (layer.pIndexDataBuckets[i].numIndices == 0) return false;
	// 		layer.pIndexDataBuckets[i].pIndices = new index_t[layer.pIndexDataBuckets[i].numIndices];
	// 		readData(&pData, layer.pIndexDataBuckets[i].pIndices, size);
	// 		if (!checkMarker(&pData, MAPFILEIO_SECURITYCHECKPOINT))	return false;
	// 	}
	// }
	// else
	// 	layer.pIndexDataBuckets = NULL;

	// if (!checkMarker(&pData, MAPFILEIO_SECURITYCHECKPOINT))	return false;


}

return (null)
}


export default WebGLNavigation2DSim



/*!****************************************************************************
 @Function		NewDemo
 @Return		pvrShell*		The demo supplied by the user
 @Description	This function must be implemented by the user of the shell.
				The user should return its pvrShell object defining the
				behaviour of the application.
//******************************************************************************/
//pvrShell* NewDemo()
//{
//	return new OGLES2Navigation();
//}

/******************************************************************************
 End of file (OGLES2Navigation.cpp)
******************************************************************************/


